import { useDispatch, useSelector } from "react-redux";

import {Typography} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import FiltersSection from "../../Filters/FiltersSection";
import {makeStyles} from "@material-ui/core/styles";
import {getTempoEtapas} from "../../../actions/orderActions"
import {getEtapas} from "../../../actions/stationActions";

import Button from "@material-ui/core/Button";
import {convertSecondsToMinutesSecondsFormat} from "../../../common/Util";
import Paper from "@material-ui/core/Paper/Paper";
import MaterialTable from "material-table";
import {tableIcons} from "../../../utils/utils";
import ExportarTemposEtapasXLS from "./exportarTemposEtapasXLS";


const useStyles = makeStyles(theme => ({
    dashboardSection: {
        // padding: "5px"
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    marginTop: {
        marginTop: theme.spacing(1) * 4
    },
    marginBottom: {
        marginBottom: theme.spacing(1) * 5,
    },
    marginBottomCharts: {
        margin: theme.spacing(1) * 3,
    },
    marginRight: {
        paddingRight: theme.spacing(1) * 2
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
}));

const TempoEtapas = ({

                    }) => {
    const classes = useStyles();

    const [show, setShow] = useState(false);
    const st = useSelector(state => state);
    console.log("REDUX STATE", st)
    const etapas = useSelector(state => state.stations.etapas);
    const tempoEtapas = useSelector(state => state.ordemServicoReducer.tempoEtapas);
    const periodMin = useSelector(state => state.filter.periodMin);
    const periodMax = useSelector(state => state.filter.periodMax);
    const loading = useSelector(state => state.ordemServicoReducer.isFetchingTempoEtapas);

    const dispatch = useDispatch();

    useEffect( () => {
        console.log("useEffect 0,0 getEtapas");
        //dispatch(getEtapas());
        dispatch(getTempoEtapas());
    }, []);

    // useEffect(() => {
    //     dispatch(getTempoEtapas());
    // }, [periodMin]);
    //
    // useEffect(() => {
    //     dispatch(getTempoEtapas());
    // }, [periodMax]);


    const onFilterClick = () => {
        dispatch(getTempoEtapas());
    }


    const getColumns = () =>  {
        return [
            {
                title: 'Medida',
                field: 'medida',
                editable: 'never',
                hidden: false,
                render: d => d.medida.replace(',','.')
            },

            {
                title: 'Sequencia',
                field: 'sequencia',
                editable: 'never',
                cellStyle: {
                    justifyContent: 'flex-end',
                    alignContent: 'flex-end',
                    textAlign: 'center'
                },
            },
            {
                title: 'Etapa',
                field: 'abreviatura',
                editable: 'never',
                cellStyle: {
                    justifyContent: 'flex-end',
                    alignContent: 'flex-end',
                    textAlign: 'center'
                },
            },
            {
                title: 'Validade Min (hh)mm:ss',
                field: 'etapaValidaTempoMinimoSec',
                editable: 'never',
                cellStyle: {
                    justifyContent: 'flex-end',
                    alignContent: 'flex-end',
                    textAlign: 'center'
                },
                render: d => convertSecondsToMinutesSecondsFormat( (d.etapaValidaTempoMinimoSec * 1).toFixed())
            },
            {
                title: 'Validade Max (hh)mm:ss',
                field: 'etapaValidaTempoMaximoSec',
                editable: 'never',
                cellStyle: {
                    justifyContent: 'flex-end',
                    alignContent: 'flex-end',
                    textAlign: 'center'
                },
                render: d => convertSecondsToMinutesSecondsFormat( (d.etapaValidaTempoMaximoSec * 1).toFixed())
            },
            {
                title: 'Ciclos validos',
                field: 'valido',
                editable: 'never',
                cellStyle: {
                    justifyContent: 'flex-end',
                    alignContent: 'flex-end',
                    textAlign: 'center'
                },
            },


            {
                title: '# Ciclos',
                field: 'qtde',
                editable: 'never',
                cellStyle: {
                    justifyContent: 'flex-end',
                    alignContent: 'flex-end',
                    textAlign: 'center'
                },
            },
            {
                title: 'Menor tempo',
                field: 'minTempoSec',
                editable: 'never',
                cellStyle: {
                    justifyContent: 'flex-end',
                    alignContent: 'flex-end',
                    textAlign: 'center'
                },
                render: d => convertSecondsToMinutesSecondsFormat( (d.minTempoSec * 1).toFixed())
            },
            {
                title: 'Media tempo',
                field: 'avgTempoSec',
                editable: 'never',
                cellStyle: {
                    justifyContent: 'flex-end',
                    alignContent: 'flex-end',
                    textAlign: 'center'
                },
                render: d => convertSecondsToMinutesSecondsFormat( (d.avgTempoSec * 1).toFixed())
            },
            {
                title: 'Max tempo',
                field: 'maxTempoSec',
                editable: 'never',
                cellStyle: {
                    justifyContent: 'flex-end',
                    alignContent: 'flex-end',
                    textAlign: 'center'
                },
                render: d => convertSecondsToMinutesSecondsFormat( (d.maxTempoSec * 1).toFixed())
            },

        ];
    }

    const downloadFile = () => {
        console.log("clicado DownloadFile");
        return (<ExportarTemposEtapasXLS dataSet={tempoEtapas}/>)
    }

    return (
        <React.Fragment>
            <Grid container direction="column" className={classes.dashboardSection}>
                <Grid item xs={12}>
                    <FiltersSection showPeriod={true} showBeforePeriod={false} showBenchPeriod={false} loading={loading} onFilterClick={onFilterClick} />
                </Grid>
            </Grid>
            <Grid item  xs={12} sm={12} lg={12} xl={12}>
                <Typography variant="h4" align="center" className={classes.sectionTitle}>
                    TEMPOS POR ETAPA - PNEU <ExportarTemposEtapasXLS dataSet={tempoEtapas}/>
                </Typography>
            </Grid>
            <Grid item  xs={12} sm={12} lg={12} xl={12}>

                    <Paper>
                        <MaterialTable
                            icons={tableIcons}
                            title="Tempos por medida de pneu"

                            columns={getColumns()}
                            data={tempoEtapas}
                            options={{
                                filtering: true,
                                pageSize: 100,
                                pageSizeOptions: [5,10,20,50,100],
                                exportButton: false
                            }}

                        />
                    </Paper>







            </Grid>
        </React.Fragment>
    )

}

export default TempoEtapas;
